export const references = {
    en: {
        references: 'References',
        referencesTitle: 'Where our information comes from',
        referencesIntro: 'SecurePath lessons are built on reporting and guidance from these security researchers, vendors, and consumer-protection organizations.',
        referencesByLesson: 'Sources by module',
        referencesByLessonIntro: 'Open a module to see every source behind its lessons: the links shown in the lessons, plus further reading from our research, with the date we last reviewed each one.',
        referencesGeneral: 'Canonical sources we rely on',
        referencesLastRead: 'Last read',
        referencesFurtherReading: 'further reading',
    },
    pt: {
        references: 'Referências',
        referencesTitle: 'De onde vem nossas informações',
        referencesIntro: 'As lições da SecurePath são construídas com base em reportagens e orientações destes pesquisadores de segurança, fabricantes e órgãos de proteção ao consumidor.',
        referencesByLesson: 'Fontes por módulo',
        referencesByLessonIntro: 'Abra um módulo para ver todas as fontes por trás das lições: os links exibidos nas lições, mais leituras adicionais da nossa pesquisa, com a data em que revisamos cada uma.',
        referencesGeneral: 'Fontes canônicas que usamos',
        referencesLastRead: 'Última leitura',
        referencesFurtherReading: 'leitura adicional',
    },
    es: {
        references: 'Referencias',
        referencesTitle: 'De dónde viene nuestra información',
        referencesIntro: 'Las lecciones de SecurePath se basan en reportajes y guías de estos investigadores de seguridad, fabricantes y organizaciones de protección al consumidor.',
        referencesByLesson: 'Fuentes por módulo',
        referencesByLessonIntro: 'Abre un módulo para ver todas las fuentes detrás de sus lecciones: los enlaces mostrados en las lecciones, más lecturas adicionales de nuestra investigación, con la fecha en que revisamos cada una.',
        referencesGeneral: 'Fuentes canónicas que usamos',
        referencesLastRead: 'Última lectura',
        referencesFurtherReading: 'lectura adicional',
    }
};
